<div [class.sidebar]="isDialog">
  <div class="dialog-actions">
    @if (dialogOptions.closable) {
      <button [mat-dialog-close]="componentResult" mat-mini-fab aria-label="Close Sidebar">
        <mat-icon title="Close Sidebar">close</mat-icon>
      </button>
    }

    @if (initialized) {
      <button mat-mini-fab (click)="toggleForm(material, true)"
        [disabled]="!('update' | able: material)">
        <mat-icon>edit</mat-icon>
      </button>
    }
  </div>

  <div class="container">
    <!-- title section -->
    <section class="header">
      <div class="title">
        @if (material?.id) {
          {{material.name}}
        }
        @if (!material?.id) {
          Add Material
        }
      </div>
    </section>
    <!-- /title section -->
  </div>

  <mat-tab-group selectedIndex="0">
    <mat-tab label="Details">
      <ng-template matTabContent>
        @if (initialized) {
          <ng-container *ngTemplateOutlet="InputFormContent"></ng-container>
        }
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>


<ng-template #InputFormContent>
  <!-- Input Form -->
  <form [formGroup]="inputForm">
    <div class="container">
      <!-- name section -->
      <section>
        <div class="mat-body-2 row">Name:</div>
        @if (!editing) {
          <div class="mat-body">{{material.name}}</div>
        }
        @if (editing) {
          <mat-form-field>
            <input matInput type="text" autocomplete="off" formControlName="name" [errorStateMatcher]="matcher" />
            @if (inputForm.controls.name.hasError('required')) {
              <mat-error>
                This field is <strong>required</strong>
              </mat-error>
            }
            @if (inputForm.controls.name.hasError('error')) {
              <mat-error>
                {{inputForm.controls.name.errors.error}}
              </mat-error>
            }
          </mat-form-field>
        }
      </section>
      <!-- /name section -->

      <!-- uom section -->
      <section>
        <div class="mat-body-2 row">UOM:</div>
        @if (!editing) {
          <div class="mat-body">{{material.uom}}</div>
        }
        @if (editing) {
          <mat-form-field>
            <input matInput type="text" autocomplete="off" formControlName="uom" [errorStateMatcher]="matcher" />
            @if (inputForm.controls.uom.hasError('required')) {
              <mat-error>
                This field is <strong>required</strong>
              </mat-error>
            }
            @if (inputForm.controls.uom.hasError('error')) {
              <mat-error>
                {{inputForm.controls.uom.errors.error}}
              </mat-error>
            }
          </mat-form-field>
        }
      </section>
      <!-- /uom section -->

      <!-- track_received section -->
      <section>
        <div class="mat-body-2 row">
          <div>Track received:</div>
          <div class="icons">
            @if (!editing) {
              @if (material?.track_received) {
                Yes
              }
              @if (!material?.track_received) {
                No
              }
            }
            @if (editing) {
              <mat-slide-toggle formControlName="track_received"></mat-slide-toggle>
              @if (inputForm.controls.track_received.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.track_received.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.track_received.errors.error}}
                </mat-error>
              }
            }
          </div>
        </div>
      </section>
      <!-- /track_received section -->

      <!-- track_used section -->
      <section>
        <div class="mat-body-2 row">
          <div>Track used:</div>
          <div class="icons">
            @if (!editing) {
              @if (material?.track_used) {
                Yes
              }
              @if (!material?.track_used) {
                No
              }
            }
            @if (editing) {
              <mat-slide-toggle formControlName="track_used"></mat-slide-toggle>
              @if (inputForm.controls.track_used.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.track_used.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.track_used.errors.error}}
                </mat-error>
              }
            }
          </div>
        </div>
      </section>
      <!-- /track_used section -->

      <!-- Form Actions -->
      <section>
        @if (editing) {
          <div class="row">
            <button mat-stroked-button color="accent" (click)="save()">
              @if (material?.id) {
                Update
              }
              @if (!material?.id) {
                Create
              }
            </button>
            <button mat-stroked-button (click)="onCancel()">Cancel</button>
          </div>
        }
      </section>
      <!-- Form Actions -->
    </div>
  </form>
  <!-- /Input form -->
</ng-template>